import { all } from 'redux-saga/effects'
import { authSagas } from '../../common/auth/authSagas'
import { integrationSagas } from '../../common/integration/integrationSagas'
import { languageSagas } from '../../common/language/languageSagas'
import { routerSaga } from '../../common/Routes/RouterSaga'
import { activityManagementSagas } from '../../views/Activity/store/ActivitySagas'
import { benefitsManagementSagas } from '../../views/ChallengeAdmin/store/ChallengeAdminSagas'
import { forgotPasswordSagas } from '../../views/ForgotPassword/store/ForgotPasswordSagas'
import { loginSagas } from '../../views/Login/store/LoginSagas'
import { signUpSagas } from '../../views/SignUp/store/SignUpSagas'
import { registerUserSagas } from '../../views/RegisterUser/store/RegisterUserSagas'
import { resetPasswordSagas } from '../../views/ResetPassword/store/ResetPasswordSagas'
import { settingsSagas } from '../../views/Settings/store/SettingsSagas'
import { statisticsSagas } from '../../views/Statistics/store/StatisticsSagas'
import { progressSagas } from '../../views/Progress/store/ProgressSagas'
import { userManagementSagas } from '../../views/UserManagement/store/UserManagementSagas'
import { companyRankingSagas } from '../../views/CompanyRanking/store/CompanyRankingSagas'
import { googleSignInSagas } from '../../components/YumGoogleSignIn/store/GoogleSignInSagas'
import { appleSignInSagas } from '../../components/YumAppleSignIn/store/AppleSignInSagas'
import { dashboardSagas } from '../../views/Dashboard/store/DashboardSagas'
import { teamManagementSagas } from '../../views/TeamManagement/store/TeamManagementSagas'
import { announcementsSagas } from '../../views/Announcements/store/AnnouncementsSagas'
import { inboxSagas } from '../../views/Inbox/store/InboxSagas'
import { activitiesSagas } from '../../views/Activities/store/ActivitiesSagas'
import { uploadSagas } from '../../components/YumUpload/store/UploadSagas'
import { userPreferencesSagas } from '../../views/NotificationPreferences/store/NotificationPreferencesSagas'
import { ssoAdminSagas } from '../../views/SsoAdmin/store/SsoAdminSagas'
import { domainAdminSagas } from '../../views/DomainAdmin/store/DomainAdminSagas'
import { signUpCodeAdminSagas } from '../../views/SignUpCodeAdmin/store/SignUpCodeAdminSagas'
import { companyAdminSagas } from '../../views/CompanyAdmin/store/CompanyAdminSagas'
import { featuresAdminSagas } from '../../views/FeaturesAdmin/store/FeaturesAdminSagas'
import { superAdminSagas } from '../../views/SuperAdmin/store/SuperAdminSagas'
import { importUsersAdminSagas } from '../../views/ImportUsersAdmin/store/ImportUsersAdminSagas'
import { importDataAdminSagas } from '../../views/ImportDataAdmin/store/ImportDataAdminSagas'
import { verifyEmailSagas } from '../../views/VerifyEmail/store/VerifyEmailSagas'
import { myGroupsSagas } from '../../views/MyGroups/store/MyGroupsSagas'
import { chatSagas } from '../../views/Chat/store/ChatSagas'

export function* appSagas() {
  yield all([
    authSagas(),
    integrationSagas(),
    loginSagas(),
    signUpSagas(),
    userManagementSagas(),
    teamManagementSagas(),
    announcementsSagas(),
    inboxSagas(),
    activitiesSagas(),
    userPreferencesSagas(),
    settingsSagas(),
    registerUserSagas(),
    activityManagementSagas(),
    benefitsManagementSagas(),
    routerSaga(),
    languageSagas(),
    statisticsSagas(),
    dashboardSagas(),
    progressSagas(),
    forgotPasswordSagas(),
    resetPasswordSagas(),
    companyRankingSagas(),
    googleSignInSagas(),
    appleSignInSagas(),
    uploadSagas(),
    ssoAdminSagas(),
    domainAdminSagas(),
    signUpCodeAdminSagas(),
    companyAdminSagas(),
    featuresAdminSagas(),
    superAdminSagas(),
    importUsersAdminSagas(),
    importDataAdminSagas(),
    verifyEmailSagas(),
    myGroupsSagas(),
    chatSagas(),
  ])
}
